<template>
<div class="loginMainContainer">
  <!-- <h3 class="loginTitle">{{sysName}}</h3> -->
  <div class="formBox">
    <login-form></login-form>
  </div>
</div>
</template>

<script>
import LoginForm from "@/components/login/loginForm";

export default {
  components: {
    LoginForm
  },
  data() {
    return {
      sysName: ''
    };
  },
  mounted() {
    // this.getSysName()
  },
  methods: {
    getSysName() {    //http://10.107.9.13:9002
      this.$axios.get(this.adminUrlAddr+"/admin/config/query").then(res => {
        console.log(res.data);
        if(res.data.code==200){
          let nameItem = res.data.data.filter(item=>item.code=='SYS_NAME')
          this.sysName= nameItem[0].value
          document.title=nameItem[0].value
        }else if(res.data.code==500){
          this.msg.warn(res.data.msg)
          return
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.loginMainContainer {
  position: relative;
  height: 100%;
  overflow: hidden;

  .loginTitle {
    margin: 0px 0 30px;
    height: 30px;
    font-size: 30px;
    color: #fff;
    line-height: 30px;
    position: relative;
    padding: 0 20px;
    //  &::after {
    //    position: absolute;
    //    content: "";
    //    bottom: -8px;
    //    left: 0;
    //    width: 100%;
    //    height: 2px;
    //    background: rgba(0, 102, 102, 0.3);
    //  }
  }
}
</style>
